import Vue from 'vue';
import Router from 'vue-router';
import store from '@/config/store';
import { EntryPermissionValid } from '@/tools/entry.ts';

Vue.use(Router);

const router: Router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'root',
      component: () => import(/* webpackChunkName: "LandingsPage" */ '@/views/LandingsPage/LandingsPage'),
    },
    {
      path: '/worldmap',
      name: 'worldmap',
      component: () => import(/* webpackChunkName: "LandingsPage" */ '@/views/LandingsPage/LandingsPage'),
    },
    {
      path: '/participate',
      name: 'participate',
      component: () => import(/* webpackChunkName: "participate" */ '@/views/Participate/Participate'),
    },
    {
      path: '/participate/augmented',
      name: 'participate ar',
      component: () => import(/* webpackChunkName: "participatear" */ '@/views/Participate/ParticipateAr/ParticipateAr'),
    },
    {
      path: '/participate/online/login',
      name: 'participate online',
      component: () => import(/* webpackChunkName: "participateonline" */ '@/views/Participate/ParticipateOnline/ParticipateOnline'),
    },
    {
      path: '/entry',
      name: 'entry',
      component: () => import(/* webpackChunkName: "entrywall" */ '@/views/EntryWall/EntryWall'),
    },
    {
      path: '/location-preferences',
      name: 'LocationPreferences',
      component: () => import(/* webpackChunkName: "locationpreferences" */ '@/views/LocationPreferences/LocationPreferences'),
    },
    {
      path: '/participate/online',
      name: 'performance shop',
      component: () => import(/* webpackChunkName: "performanceshop" */ '@/views/PerformanceShop/PerformanceShop'),
      beforeEnter: (to, from, next) => {
        if (!store.state.user) next({path: '/participate/online/login'});
        else next();
      }
    },
    {
      path: '/performance-shop/:id',
      name: 'performance shop detail',
      component: () => import(/* webpackChunkName: "performancedetail" */ '@/views/PerformanceShop/PerformanceDetail/PerformanceDetail'),
      beforeEnter: (to, from, next) => {
        if (!store.state.user) next({path: '/login'});
        else next();
      }
    },
    {
      path: '/mission',
      name: 'concept',
      component: () => import(/* webpackChunkName: "concept" */ '@/views/Concept/Concept'),
    },
    {
      path: '/pilot',
      name: 'pilot',
      component: () => import(/* webpackChunkName: "pilot" */ '@/views/Pilot/Pilot'),
    },
    {
      path: '/views',
      name: 'views',
      component: () => import(/* webpackChunkName: "verifiedviews" */ '@/views/VerifiedViews/VerifiedViews'),
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import(/* webpackChunkName: "contact" */ '@/views/Contact/Contact'),
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/Dashboard'),
      beforeEnter: (to, from, next) => {
        if (!store.state.user) next({path: '/login'});
        else next();
      }
    },
    {
      path: '/partners',
      name: 'partners',
      component: () => import(/* webpackChunkName: "partners" */ '@/views/Partners/Partners'),
      beforeEnter: (to, from, next) => {
        if (!store.state.user) next({path: '/login'});
        else next();
      }
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.name === 'entry') {
    next();
  } else if (!EntryPermissionValid()) {
    localStorage.removeItem('allowEntry');
    next({path: '/entry'});
  } else {
    next();
  }
});

export default router;
